/*
 * dän pickup cart drawer (readable since 2026-10-16, ordering rules v2).
 * Pickup is next-day with a 6 PM cutoff; same-day only for what the store's Square count shows
 * (≤ 6 per item, from 30 min out; drinks always). Config: window.DAN_ORDERING (shop metafield
 * dan.ordering, set in snippets/dan-store.liquid). BakeOps re-checks every paid order with the same rules.
 * Order attributes written at checkout are unchanged: BakeOps reads them for the Square ticket.
 * v4.0 (2026-10-18): order ahead — the day list is short, but the day the customer chose on a product page or
 * in "Later date" is always kept, up to DAN_ORDERING.maxDaysAhead (default 90) days out, on any open day.
 */
!(function () {
  var t,
    e = window.DAN_STORES || {},
    n = (window.DAN_ADDONS, { cart: null, day: null, time: null, chosen: !1, note: null, err: "", busy: !1 }),
    a = document.querySelector("[data-dan-cart]"),
    r = null;
  function o(t, e) {
    return (e || document).querySelector(t);
  }
  function i(t) {
    return "$" + (t / 100).toFixed(2);
  }
  function d(t) {
    return String(null == t ? "" : t).replace(/[&<>"']/g, function (t) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[t];
    });
  }
  function s() {
    try {
      var t = localStorage.getItem("danStore");
      return e[t] ? t : null;
    } catch (t) {
      return null;
    }
  }
  function c(t, e) {
    var n = { headers: { Accept: "application/json" } };
    return (
      e && ((n.method = "POST"), (n.headers["Content-Type"] = "application/json"), (n.body = JSON.stringify(e))),
      fetch(t, n).then(function (t) {
        return t.json().then(function (e) {
          if (!t.ok) throw new Error(e.description || e.message || "Something went wrong. Please try again.");
          return e;
        });
      })
    );
  }
  function u(t) {
    return "add-ons" === t.handle;
  }
  function l(t) {
    return (window.DAN_KITCHEN_HANDLES || []).indexOf(t.handle) > -1;
  }
  function p(t) {
    return !(!t || !t.items.some(l));
  }
  function f(t) {
    return p(t) ? "morristown" : s();
  }
  function h(t) {
    return t
      ? t.items.reduce(function (t, e) {
          return t + (u(e) ? 0 : e.quantity);
        }, 0)
      : 0;
  }
  /* Ordering rules (owner, 2026-10-16) — the same rules BakeOps re-checks before a ticket reaches the till.
     Config: window.DAN_ORDERING (shop metafield dan.ordering). Pickup is next-day with a 6 PM cutoff; same-day
     only for what the store's Square count shows (≤ 6 per item, from 30 min out); drinks are always fine
     same-day; a cart with catering items follows catering lead times (next day, or 48 h for fresh items). */
  var R0 = window.DAN_ORDERING || {};
  function hOf(x, d) {
    var p = String(x || d).split(":");
    return +p[0] + (+p[1] || 0) / 60;
  }
  /* Whole cakes come from the freezer: a cakes-only cart may order for tomorrow until cakeCutoff (10 PM). */
  var WHOLE_CAKE = /^CKE-.+-WHL(8)?(PS)?$/;
  function cakesOnly(t) {
    var food = ((t && t.items) || []).filter(function (i) {
      return !u(i) && !isDrink(i);
    });
    return (
      food.length > 0 &&
      food.every(function (i) {
        return WHOLE_CAKE.test(i.sku || "");
      })
    );
  }
  function cutH(t) {
    return t && cakesOnly(t) ? hOf(R0.cakeCutoff, "22:00") : hOf(R0.pickupCutoff, "18:00");
  }
  function cutLabel(t) {
    var h = cutH(t),
      H = Math.floor(h),
      m = Math.round((h - H) * 60);
    return (H % 12 || 12) + (m ? ":" + (m < 10 ? "0" : "") + m : "") + " " + (H >= 12 ? "PM" : "AM");
  }
  var LEAD = (+R0.sameDayLeadMinutes || 30) / 60,
    CAP = +R0.sameDayMaxPerItem || 6,
    STEP = (+R0.slotMinutes || 15) / 60,
    AHEAD = +R0.maxDaysAhead || 90;
  function isDrink(t) {
    return (window.DAN_SAMEDAY_OK || []).indexOf(t.handle) > -1;
  }
  function isCat(t) {
    return /catering/i.test(t.product_type || "");
  }
  function is48(t) {
    return (window.DAN_LEAD48 || []).indexOf(t.handle) > -1;
  }
  function hasCat(t) {
    return !!(t && t.items && t.items.some(isCat));
  }
  /* The first day other than today: tomorrow, or the day after once it is past the cutoff; catering 48 h items one more. */
  function firstDay(t) {
    if (hasCat(t)) return (t.items.some(is48) ? 2 : 1) + (v().h >= hOf(R0.pickupCutoff, "18:00") ? 1 : 0);
    return 1 + (v().h >= cutH(t) ? 1 : 0);
  }
  function v() {
    var t = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: !1,
      }).formatToParts(new Date()),
      e = {};
    return (
      t.forEach(function (t) {
        e[t.type] = t.value;
      }),
      { y: +e.year, m: +e.month, d: +e.day, h: (+e.hour % 24) + +e.minute / 60 }
    );
  }
  function y(t) {
    var e = v(),
      n = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
    return {
      k: t,
      dow: n.getUTCDay(),
      iso: n.toISOString().slice(0, 10),
      label:
        0 === t
          ? "Today"
          : 1 === t
            ? "Tomorrow"
            : n.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" }),
    };
  }
  function b(t) {
    var e = Math.floor(t + 1e-9),
      n = Math.round(60 * (t - e));
    return (e % 12 || 12) + ":" + (n < 10 ? "0" : "") + n + " " + (e >= 12 ? "PM" : "AM");
  }
  /* Opening hours on day k (null = closed that weekday or a closed date). */
  function hoursOn(a, k) {
    var s = e[a],
      info = y(k),
      h = s && s.hours ? s.hours[info.dow] : null;
    if (!h || (s.closedDates || []).indexOf(info.iso) > -1) return null;
    return h;
  }
  function _(k, t, a, today) {
    var h = hoursOn(a, k),
      out = [];
    if (!h) return out;
    var start = h[0];
    if (today) start = Math.max(start, Math.ceil((v().h + LEAD) / STEP - 1e-9) * STEP);
    for (var d = start; d <= h[1] - STEP + 1e-9; d += STEP) out.push(Math.round(d / STEP) * STEP);
    return out;
  }
  /* The days offered: today only when the cart may be had today, then from firstDay on — ten open days, plus the
     day the customer asked for (product page or "Later date") when it is further out, up to AHEAD days. */
  function kOf(iso) {
    var t = v();
    return Math.round((Date.parse(iso + "T00:00:00Z") - Date.UTC(t.y, t.m - 1, t.d)) / 864e5);
  }
  function g(t, a, sameDayOk) {
    var out = [],
      want = n.day;
    try {
      want = localStorage.getItem("danPickupDay") || want;
    } catch (x) {}
    if (sameDayOk && !hasCat(t)) {
      var s0 = _(0, t, a, !0);
      s0.length && out.push({ info: y(0), slots: s0 });
    }
    for (var k = firstDay(t); k < 21 && out.length < 10; k++) {
      var s = _(k, t, a, !1);
      s.length && out.push({ info: y(k), slots: s });
    }
    var kw = want ? kOf(want) : -1,
      last = out.length ? out[out.length - 1].info.k : 0;
    if (kw > last && kw >= firstDay(t) && kw <= AHEAD) {
      var sw = _(kw, t, a, !1);
      sw.length && out.push({ info: y(kw), slots: sw });
    }
    return out;
  }
  /* "Later date": any open day from the first allowed one to AHEAD days out. */
  function pickDate(iso) {
    var t = n.cart,
      a = f(t),
      k = iso ? kOf(iso) : NaN;
    n.dateErr = "";
    if (!t || !a || !(k >= 0)) return L();
    if (k < firstDay(t) || k > AHEAD)
      n.dateErr = "Please choose a date between " + y(firstDay(t)).label + " and " + y(AHEAD).label + ".";
    else if (!hoursOn(a, k)) n.dateErr = e[a].short + " is closed that day. Please choose another date.";
    else (n.day = iso), (n.time = null), (n.chosen = !0), (n.err = "");
    L();
  }
  function todayOpen(t, a) {
    return !hasCat(t) && _(0, t, a, !0).length > 0;
  }
  var k = /^CKE-.+-WHL8(PS)?$/,
    A = {},
    S = {},
    P = null;
  function O() {
    return y(0).iso;
  }
  function E(t) {
    var e = {};
    return (
      (t && t.items ? t.items : []).forEach(function (t) {
        if (t.sku && k.test(t.sku)) {
          var n = t.sku.replace(/PS$/, "");
          (e[n] = e[n] || { qty: 0, name: t.product_title }).qty += t.quantity;
        }
      }),
      e
    );
  }
  function D(t, e, n) {
    var a = t + "|" + e,
      r = A[a];
    if (!n && r && Date.now() - r.t < 6e4) return r.p;
    var o = Promise.race([
      fetch("https://bakeops-production.up.railway.app/api/public/availability?store=" + t + "&date=" + e, {
        headers: { Accept: "application/json" },
      }).then(function (t) {
        if (!t.ok) throw new Error("av");
        return t.json();
      }),
      new Promise(function (t, e) {
        setTimeout(function () {
          e(new Error("timeout"));
        }, 4e3);
      }),
    ]);
    return (
      (A[a] = { t: Date.now(), p: o }),
      o.catch(function () {
        delete A[a];
      }),
      o
    );
  }
  function j(t, e) {
    var n = E(t),
      a = [];
    return (
      Object.keys(n).forEach(function (t) {
        var r = e.items[t];
        r &&
          "unknown" !== r.status &&
          "not_offered" !== r.status &&
          null != r.available &&
          n[t].qty > r.available &&
          a.push({ name: n[t].name, qty: n[t].qty, left: r.available });
      }),
      a
    );
  }
  function T(t, e, n, a) {
    return e && n && Object.keys(E(t)).length
      ? (function (t, e, n) {
          var a = y(0).iso;
          return D(t, e, n).then(function (r) {
            var o = (r && r.items) || {},
              i = Object.keys(o).some(function (t) {
                return "cutoff" === o[t].status;
              });
            return e !== a && i
              ? D(t, a, n).then(function (t) {
                  var e = {};
                  return (
                    Object.keys(o).forEach(function (n) {
                      e[n] =
                        "cutoff" === o[n].status ? (t.items || {})[n] || { available: null, status: "unknown" } : o[n];
                    }),
                    { items: e, src: "square" }
                  );
                })
              : { items: o, src: r.source };
          });
        })(e, n, a).then(
          function (e) {
            return { short: j(t, e), src: e.src };
          },
          function () {
            return null;
          },
        )
      : Promise.resolve(null);
  }
  function q(t) {
    var e = E(t);
    return Object.keys(e)
      .sort()
      .map(function (t) {
        return t + ":" + e[t].qty;
      })
      .join(",");
  }
  /* Same-day: every item that is not a drink or add-on must be in this store's Square count today,
     at most CAP each. Resolves {ok, missing: [names]}. Unreadable stock = not available today. */
  var SD = {};
  function sdKey(t, a) {
    return (
      a +
      "|" +
      y(0).iso +
      "|" +
      t.items
        .map(function (i) {
          return i.variant_id + ":" + i.quantity;
        })
        .join(",")
    );
  }
  function sameDay(t, a, force) {
    if (hasCat(t)) return Promise.resolve({ ok: !1, missing: [] });
    var need = t.items.filter(function (i) {
      return !u(i) && !isDrink(i);
    });
    if (!need.length) return Promise.resolve({ ok: !0, missing: [] });
    var qty = {},
      names = {},
      missing = [];
    need.forEach(function (i) {
      if (!i.sku) missing.push(i.product_title);
      else (qty[i.sku] = (qty[i.sku] || 0) + i.quantity), (names[i.sku] = i.product_title);
    });
    if (!Object.keys(qty).length) return Promise.resolve({ ok: !1, missing: missing });
    return D(a, y(0).iso, force).then(
      function (r) {
        var items = (r && r.items) || {};
        Object.keys(qty).forEach(function (s) {
          var it = items[s];
          (!it || "ok" !== it.status || null == it.available || it.available < qty[s] || qty[s] > CAP) &&
            missing.indexOf(names[s]) < 0 &&
            missing.push(names[s]);
        });
        return { ok: !missing.length, missing: missing };
      },
      function () {
        return {
          ok: !1,
          missing: need.map(function (i) {
            return i.product_title;
          }),
        };
      },
    );
  }
  function telOf(a) {
    var p = (e[a] && e[a].phone) || "";
    return '<a href="tel:' + p.replace(/[^0-9+]/g, "") + '">' + d(p) + "</a>";
  }
  function C(t, n) {
    var a = S[P];
    if (!a || !a.short.length) return "";
    var r = n === y(0).iso;
    return (
      '<p class="dc__note dc__note--av" style="background:#fdeee7;border-radius:12px;padding:10px 12px;color:#2b2a33">' +
      a.short
        .map(function (n) {
          return n.left > 0
            ? "<b>" +
                d(n.name) +
                "</b> (whole): only " +
                n.left +
                " left " +
                (r ? "today at " : "for that day at ") +
                d(e[t].short) +
                "."
            : "<b>" +
                d(n.name) +
                "</b> (whole) is sold out " +
                (r ? "today at " : "for that day at ") +
                d(e[t].short) +
                ".";
        })
        .join("<br>") +
      " " +
      (r
        ? "Please schedule a later day, choose fewer, or pick another store."
        : "Please choose another day, fewer cakes, or another store.") +
      "</p>"
    );
  }
  function L() {
    var t = r && r.offsetParent ? r : o("[data-dan-cart-body]", a);
    (P = null),
      t &&
        (t.innerHTML = (function () {
          var t = n.cart,
            a =
              '<div class="dc"><div class="dc__head"><h2 class="dc__title">Your order</h2><button type="button" class="dc__x" data-dan-cart-close aria-label="Close">&times;</button></div>';
          if (!t || (!h(t) && !t.item_count))
            return (
              a +
              '<div class="dc__empty"><p>Your order is empty.</p>' +
              (/^\/pages\/order/.test(location.pathname)
                ? "<p>Tap “+ Add” on anything to start.</p>"
                : '<a class="dc__btn" href="/pages/order">Browse the menu</a>') +
              "</div></div>"
            );
          var r = {};
          t.items.forEach(function (t) {
            var e = t.properties && t.properties._g;
            !u(t) && e && (r[e] = !0);
          });
          var o = {};
          t.items.forEach(function (t) {
            var e = t.properties && t.properties._g;
            u(t) && e && r[e] && (o[e] = o[e] || []).push(t);
          }),
            (a += '<ul class="dc__lines">'),
            t.items.forEach(function (t) {
              var e = t.properties && t.properties._g;
              (u(t) && e && r[e]) ||
                (a += (function (t, e) {
                  var n = Object.keys(t.properties || {})
                      .filter(function (e) {
                        return "_" !== e.charAt(0) && t.properties[e];
                      })
                      .map(function (e) {
                        return u(t) ? d(e + ": " + t.properties[e]) : d(t.properties[e]);
                      }),
                    a = [];
                  (u(t) || (t.variant_title && "Default Title" !== t.variant_title)) && a.push(d(t.variant_title)),
                    (a = a.concat(n)),
                    e.forEach(function (t) {
                      a.push("+ " + d(t.variant_title));
                    });
                  var r =
                    t.final_line_price +
                    e.reduce(function (t, e) {
                      return t + e.final_line_price;
                    }, 0);
                  return (
                    '<li class="dc__line">' +
                    (t.image
                      ? '<img src="' +
                        d(t.image + (t.image.indexOf("?") > -1 ? "&" : "?") + "width=120") +
                        '" alt="" width="56" height="56" loading="lazy">'
                      : '<span class="dc__ph"></span>') +
                    '<div><p class="dc__name">' +
                    d(u(t) ? "Add-on" : t.product_title) +
                    "</p>" +
                    (a.length ? '<p class="dc__meta">' + a.join(" · ") + "</p>" : "") +
                    '<div class="dc__ctl"><span class="dc__qty"><button type="button" data-dc-qty="-1" data-key="' +
                    d(t.key) +
                    '" aria-label="One less">−</button><span>' +
                    t.quantity +
                    '</span><button type="button" data-dc-qty="1" data-key="' +
                    d(t.key) +
                    '" aria-label="One more">+</button></span><button type="button" class="dc__rm" data-dc-rm="' +
                    d(t.key) +
                    '">Remove</button></div></div><span class="dc__price">' +
                    i(r) +
                    "</span></li>"
                  );
                })(t, (!u(t) && e && o[e]) || []));
            }),
            (a += "</ul>");
          var c = s(),
            l = f(t),
            v = l
              ? '<div class="dc__pk"><span>Pickup · <b>' +
                d(e[l].short) +
                "</b><br>" +
                d(e[l].address) +
                "</span>" +
                (p(t) ? "" : '<button type="button" data-dan-open-picker>Change</button>') +
                "</div>" +
                (p(t) && c && "morristown" !== c
                  ? '<div class="dc__sec" style="padding-top:0"><p class="dc__note">Breakfast plates, toasts, soups and hot meals are made in our Morristown kitchen, so this order is for pickup at <b>Morristown</b>. <button type="button" data-dc-rm-kitchen>Remove those items</button> to pick up at ' +
                    d(e[c].short) +
                    ".</p></div>"
                  : "")
              : '<div class="dc__sec" style="padding-top:0"><button type="button" class="dc__choose" data-dan-open-picker>Choose your pickup store</button></div>';
          if (((a = a.replace('<ul class="dc__lines">', v + '<ul class="dc__lines">')), l)) {
            var sk = sdKey(t, l),
              sd = SD[sk],
              open0 = todayOpen(t, l);
            open0 &&
              !sd &&
              ((SD[sk] = { pending: !0 }),
              sameDay(t, l).then(function (r) {
                (SD[sk] = r), L();
              }));
            var _ = g(t, l, !!(sd && sd.ok));
            try {
              var k = localStorage.getItem("danPickupDay");
              k &&
                (localStorage.removeItem("danPickupDay"),
                _.filter(function (t) {
                  return t.info.iso === k;
                })[0] && ((n.day = k), (n.time = null), (n.chosen = !0)));
            } catch (t) {}
            n.chosen ||
              !_[0] ||
              (n.day !== _[0].info.iso && ((n.day = _[0].info.iso), (n.time = null)));
            var A =
              _.filter(function (t) {
                return t.info.iso === n.day;
              })[0] || _[0];
            (n.day = A ? A.info.iso : null), A && A.slots.indexOf(+n.time) < 0 && (n.time = A.slots[0]);
            var D = n.day,
              j = !!(
                (P = D && Object.keys(E(t)).length ? l + "|" + D + "|" + q(t) : null) &&
                S[P] &&
                S[P].short.length
              ),
              lead = hasCat(t)
                ? t.items.some(is48)
                  ? "Prepared fresh for your date. Order by 6 PM, two days ahead."
                  : ""
                : "Order by " + cutLabel(t) + " for pickup tomorrow from opening.";
            (a +=
              '<div class="dc__sec"><p class="dc__label">Pickup day &amp; time</p>' +
              (lead ? '<p class="dc__note">' + d(lead) + "</p>" : "")),
              _.length
                ? (a +=
                    '<div class="dc__when"><select data-dc-day aria-label="Pickup day">' +
                    _.map(function (t) {
                      return (
                        '<option value="' +
                        t.info.iso +
                        '"' +
                        (t.info.iso === n.day ? " selected" : "") +
                        ">" +
                        d(t.info.label) +
                        "</option>"
                      );
                    }).join("") +
                    '</select><select data-dc-time aria-label="Pickup time">' +
                    A.slots
                      .map(function (t) {
                        return '<option value="' + t + '"' + (t === +n.time ? " selected" : "") + ">" + b(t) + "</option>";
                      })
                      .join("") +
                    "</select></div>" +
                    '<label class="dc__later" style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:10px;font-size:14px">Order further ahead<input type="date" data-dc-date min="' +
                    y(firstDay(t)).iso +
                    '" max="' +
                    y(AHEAD).iso +
                    '" value="' +
                    (n.day && kOf(n.day) > 0 ? n.day : "") +
                    '" style="font:inherit;padding:8px 10px;border:1px solid rgba(53,52,64,.32);border-radius:10px;background:#fff"></label>' +
                    (n.dateErr ? '<p class="dc__err" role="alert">' + d(n.dateErr) + "</p>" : ""))
                : (a +=
                    '<p class="dc__note">No pickup times are open in the next few days. Please call ' + telOf(l) + ".</p>"),
              open0 &&
                sd &&
                !sd.pending &&
                !sd.ok &&
                (a +=
                  '<p class="dc__note dc__note--av" style="background:#fdeee7;border-radius:12px;padding:10px 12px;color:#2b2a33">Not in the case today — order for tomorrow, or call the store. ' +
                  telOf(l) +
                  (sd.missing && sd.missing.length ? "<br><small>" + d(sd.missing.join(", ")) + "</small>" : "") +
                  "</p>"),
              j && (a += C(l, D)),
              (a += "</div>");
          }
          /* "Goes well with" — named sug, not L: as L it hid the drawer's own render from the stock callback below. */
          var sug = (window.DAN_SUGGEST || [])
            .filter(function (e) {
              return (
                e.available &&
                !t.items.some(function (t) {
                  return t.handle === e.handle;
                })
              );
            })
            .slice(0, 2);
          return (
            sug.length &&
              (a +=
                '<div class="dc__sug"><p class="dc__label">Goes well with</p><ul>' +
                sug.map(function (t) {
                  return (
                    "<li><span>" +
                    d(t.title) +
                    " · " +
                    (t.varies ? "from " : "") +
                    i(t.price) +
                    "</span>" +
                    (t.simple
                      ? '<button type="button" class="dan-add" data-dan-add="' +
                        t.variant +
                        '" data-name="' +
                        d(t.title) +
                        '" aria-label="Add ' +
                        d(t.title) +
                        '">+ Add</button>'
                      : '<button type="button" class="dan-add" data-dan-choose="' +
                        d(t.handle) +
                        '" aria-label="Add ' +
                        d(t.title) +
                        '">+ Add</button>') +
                    "</li>"
                  );
                }).join("") +
                "</ul></div>"),
            (a +=
              '<div class="dc__sec"><p class="dc__label">Notes (optional)</p><textarea class="dc__notes" data-dc-note placeholder="Allergies, a message for the cake, anything we should know">' +
              d(null != n.note ? n.note : t.note || "") +
              "</textarea></div>"),
            (a +=
              '<div class="dc__foot"><div class="dc__sub"><span>Subtotal</span><b>' +
              i(t.total_price) +
              '</b></div><p class="dc__tax">Tax calculated at checkout. Pay online now, pick up at the counter.</p><button type="button" class="dc__btn" data-dc-checkout' +
              (n.busy || (P && S[P] && S[P].short.length) ? " disabled" : "") +
              ">" +
              (n.busy ? "One moment…" : "Checkout · " + i(t.total_price)) +
              '</button><p class="dc__guest">No account needed — guest checkout</p>' +
              (n.err ? '<p class="dc__err">' + d(n.err) + "</p>" : "") +
              "</div></div>")
          );
        })()),
      P &&
        !S[P] &&
        (function () {
          var t = P;
          if (t) {
            var e = t.split("|");
            T(n.cart, e[0], e[1], !1).then(function (e) {
              var n = JSON.stringify(S[t] || null);
              (S[t] = e || { short: [] }), t === P && JSON.stringify(S[t]) !== n && L();
            });
          }
        })(),
      (function () {
        var t = h(n.cart);
        document.querySelectorAll("[data-dan-cart-count]").forEach(function (e) {
          (e.textContent = t), (e.hidden = !t);
        });
        var e = o(".dan-fab");
        e && (e.hidden = !t || !!r);
      })();
  }
  function x(t) {
    return (n.cart = t), L(), t;
  }
  function N() {
    return c("/cart.js").then(x);
  }
  function I() {
    r && r.offsetParent
      ? r.scrollIntoView({ behavior: "smooth", block: "nearest" })
      : ((a.hidden = !1), (document.documentElement.style.overflow = "hidden"), L(), N());
  }
  function M() {
    (a.hidden = !0), (document.documentElement.style.overflow = "");
  }
  function H(e) {
    var a = o("[data-dan-toast]");
    a &&
      ((a.innerHTML =
        "<span>" + d(e) + '</span><button type="button" data-dan-cart-open>View order (' + h(n.cart) + ")</button>"),
      (a.hidden = !1),
      clearTimeout(t),
      (t = setTimeout(function () {
        a.hidden = !0;
      }, 6e3)));
  }
  function U(t, e) {
    e = e || {};
    var f = !h(n.cart);
    return c("/cart/add.js", { items: t }).then(function (r) {
      return N().then(function (t) {
        try {
          (window.dataLayer = window.dataLayer || []), window.dataLayer.push({ event: "add_to_cart", dan_store: s() });
        } catch (t) {}
        var a =
            r &&
            r.items &&
            r.items.filter(function (t) {
              return !u(t);
            })[0],
          o = a
            ? a.product_title +
              (a.variant_title && "Default Title" !== a.variant_title ? " · " + a.variant_title : "") +
              " · " +
              i(a.final_line_price) +
              " added"
            : (e.name || "Item") + " added",
          w = a && /whole/i.test(a.variant_title || "");
        return e.open || (f && w) ? I() : H(o), t;
      });
    });
  }
  function $(t, e) {
    var a = n.cart.items.filter(function (e) {
      return e.key === t;
    })[0];
    if (a) {
      var r = {};
      r[t] = e;
      var o = a.properties && a.properties._g;
      return (
        o &&
          !u(a) &&
          n.cart.items.forEach(function (t) {
            u(t) && t.properties && t.properties._g === o && (r[t.key] = e);
          }),
        c("/cart/update.js", { updates: r }).then(x)
      );
    }
  }
  var R = { morristown: "76969115759", york: "91935441007", hoboken: "91935473775" };
  function B() {
    var t = n.cart,
      a = f(t);
    if (((n.err = ""), !a)) return (n.err = "Choose your pickup store above."), void L();
    var r = {
      "Pickup store": e[a].short,
      "Order source": "danbakery.us",
      "Order type": "Pickup",
      "Catering date": "",
      "Catering time": "",
      "Catering method": "",
      "Catering store": "",
      Guests: "",
      "Pre-slice cakes": "",
    };
    var today = n.day === y(0).iso,
      o = g(t, a, today).filter(function (t) {
        return t.info.iso === n.day;
      })[0];
    if (!o || o.slots.indexOf(+n.time) < 0) return (n.err = "Please choose a pickup day and time."), void L();
    (r["Pickup time"] = o.info.label + " · " + b(+n.time)), (r["Pickup date"] = o.info.iso);
    var i = r["Pickup date"];
    (n.busy = !0),
      L(),
      (today
        ? sameDay(t, a, !0).then(function (r) {
            if (((SD[sdKey(t, a)] = r), !r.ok))
              throw ((n.day = null), (n.chosen = !1), new Error("Not in the case today — order for tomorrow, or call the store."));
          })
        : Promise.resolve()
      )
        .then(function () {
          return T(t, a, i, !0);
        })
        .then(function (e) {
          if (e && e.short.length) {
            var n = a + "|" + i + "|" + q(t);
            throw ((S[n] = e), new Error("Some cakes just sold out for that pickup — see the note above."));
          }
        })
        .then(function () {
          return c("/cart/update.js", { attributes: r, note: null != n.note ? n.note : t.note || "" });
        })
        .then(function (t) {
          return (function (t, e) {
            var n = t && t.token,
              a = R[e];
            if (!n || !a || !window.fetch) return Promise.resolve();
            var r = JSON.stringify({
                query:
                  "mutation($id:ID!,$b:CartBuyerIdentityInput!){cartBuyerIdentityUpdate(cartId:$id,buyerIdentity:$b){userErrors{message}}}",
                variables: {
                  id: "gid://shopify/Cart/" + n,
                  b: { preferences: { delivery: { deliveryMethod: ["PICK_UP"], pickupHandle: [a] } } },
                },
              }),
              o = new Promise(function (t) {
                setTimeout(t, 2500);
              }),
              i = fetch("/api/2026-07/graphql.json", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: r,
              }).catch(function () {});
            return Promise.race([i, o]);
          })(t, a);
        })
        .then(function () {
          window.location.href = "/checkout";
        })
        .catch(function (t) {
          (n.busy = !1), (n.err = t.message), L();
        });
  }
  function G() {
    (r = document.querySelector("[data-dan-cart-inline]")), N().catch(function () {});
  }
  document.addEventListener(
    "click",
    function (t) {
      var e = t.target,
        a = e.closest("a[href]");
      if (a && !a.closest("[data-dan-keep]")) {
        var i;
        try {
          i = new URL(a.getAttribute("href"), location.href);
        } catch (t) {}
        if (i && i.origin === location.origin && /^\/cart\/?$/.test(i.pathname) && !r)
          return t.preventDefault(), t.stopPropagation(), void I();
      }
      var d = e.closest(
        "[data-dan-cart-open],[data-dan-cart-close],[data-dc-qty],[data-dc-rm],[data-dc-rm-kitchen],[data-dc-checkout],[data-dc-store],[data-dan-add],[data-dan-choose],[data-dan-opt-close]",
      );
      if (d) {
        if (d.hasAttribute("data-dan-cart-open")) {
          t.preventDefault();
          var s = o("[data-dan-toast]");
          return s && (s.hidden = !0), void I();
        }
        if (d.hasAttribute("data-dan-cart-close")) return t.preventDefault(), void M();
        if (d.hasAttribute("data-dan-opt-close"))
          return t.preventDefault(), void (window.danOptions && window.danOptions.close());
        if (d.hasAttribute("data-dc-qty")) {
          var p = n.cart.items.filter(function (t) {
            return t.key === d.getAttribute("data-key");
          })[0];
          p && $(p.key, Math.max(0, p.quantity + +d.getAttribute("data-dc-qty")));
        } else if (d.hasAttribute("data-dc-rm")) $(d.getAttribute("data-dc-rm"), 0);
        else {
          if (d.hasAttribute("data-dc-rm-kitchen"))
            return (
              (f = {}),
              n.cart.items.forEach(function (t) {
                if (l(t)) {
                  f[t.key] = 0;
                  var e = t.properties && t.properties._g;
                  e &&
                    n.cart.items.forEach(function (t) {
                      u(t) && t.properties._g === e && (f[t.key] = 0);
                    });
                }
              }),
              void c("/cart/update.js", { updates: f }).then(x)
            );
          var f;
          if (d.hasAttribute("data-dc-checkout")) B();
          else if (d.hasAttribute("data-dc-store")) {
            var h = d.getAttribute("data-dc-store");
            if (((n.err = ""), window.danSetStore)) window.danSetStore(h);
            else {
              try {
                localStorage.setItem("danStore", h);
              } catch (t) {}
              L();
            }
          } else {
            if (d.hasAttribute("data-dan-choose"))
              return (
                t.preventDefault(),
                void (window.danOptions
                  ? window.danOptions.open(d.getAttribute("data-dan-choose"))
                  : (window.location.href = "/products/" + d.getAttribute("data-dan-choose")))
              );
            if (d.hasAttribute("data-dan-add")) {
              if ((t.preventDefault(), d.disabled)) return;
              var m = d.innerHTML;
              (d.disabled = !0),
                U([{ id: +d.getAttribute("data-dan-add"), quantity: 1 }], { name: d.getAttribute("data-name") })
                  .then(function () {
                    d.classList.add("is-done"),
                      (d.textContent = "Added ✓"),
                      setTimeout(function () {
                        d.classList.remove("is-done"), (d.innerHTML = m), (d.disabled = !1);
                      }, 1400);
                  })
                  .catch(function (t) {
                    (d.innerHTML = m), (d.disabled = !1), H(t.message);
                  });
            }
          }
        }
      }
    },
    !0,
  ),
    document.addEventListener("change", function (t) {
      var e = t.target;
      e.hasAttribute && e.hasAttribute("data-dc-day")
        ? ((n.day = e.value), (n.time = null), (n.chosen = !0), (n.err = ""), (n.dateErr = ""), L())
        : e.hasAttribute && e.hasAttribute("data-dc-date")
          ? pickDate(e.value)
          : e.hasAttribute && e.hasAttribute("data-dc-time") && (n.time = +e.value);
    }),
    document.addEventListener("input", function (t) {
      t.target.hasAttribute && t.target.hasAttribute("data-dc-note") && (n.note = t.target.value);
    }),
    document.addEventListener("keydown", function (t) {
      "Escape" === t.key && (window.danOptions && window.danOptions.close(), r || M());
    }),
    window.addEventListener("dan:store", function () {
      n.cart && L();
    }),
    window.addEventListener("pageshow", function (t) {
      (n.busy = !1), t.persisted ? N() : n.cart && L();
    }),
    (window.danCart = {
      open: I,
      close: M,
      add: U,
      refresh: N,
      isOpen: function () {
        return !a.hidden;
      },
    }),
    "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", G) : G();
})();
